<template>
    <div class="warpper">
        <div class="top">
            <div class="select_warpper">
                <p>柜台</p>
                <mySelect
                    placeholders="请选择柜台"
                    class="select_container"
                    :multiple="true"
                    v-model="analyseForm.counter_no"
                    :options="pullData.counter_arr"
                    values="kind_no"
                    labels="kind_name"
                    keys="kind_no"
                >
                </mySelect>
            </div>
            <div class="select_warpper">
                <p>品类</p>
                <mySelect
                    placeholders="请选择品类"
                    class="select_container"
                    :multiple="true"
                    v-model="analyseForm.type_no"
                    :options="pullData.type_arr"
                    values="kind_no"
                    labels="kind_name"
                    keys="kind_no"
                >
                </mySelect>
            </div>
            <div class="select_warpper">
                <p>品目</p>
                <mySelect
                    placeholders="请选择品目"
                    class="select_container"
                    :multiple="true"
                    v-model="analyseForm.kind_no"
                    :options="pullData.kind_arr"
                    values="kind_no"
                    labels="kind_name"
                    keys="kind_no"
                >
                </mySelect>
            </div>
            <div class="select_warpper">
                <p>金成色</p>
                <mySelect
                    placeholders="请选择金成色"
                    class="select_container"
                    :multiple="true"
                    v-model="analyseForm.gold_no"
                    :options="pullData.gold_arr"
                    values="kind_no"
                    labels="kind_name"
                    keys="kind_no"
                >
                </mySelect>
            </div>
            <div class="select_warpper">
                <p>产品</p>
                <mySelect
                    placeholders="请选择产品"
                    class="select_container"
                    :multiple="true"
                    v-model="analyseForm.style_no"
                    :options="pullData.style_arr"
                    values="style_no"
                    labels="style_name"
                    keys="style_no"
                >
                </mySelect>
            </div>
            <el-button type="primary" size="medium" class="buttom" @click="cencel()">清空</el-button>
            <el-button type="primary" size="medium" class="buttom" @click="onscreen()">{{ $t('common.filter') }}</el-button>
        </div>
        <div class="center">
            <div class="screen_table">
                <div class="table_top">
                    <p>柜台库存</p>
                    <el-button type="warning" size="mini" @click="setCurrent()">取消关联</el-button>
                </div>
                <el-table
                    class="el_table"
                    :data="counterData"
                    ref="singleTable"
                    border
                    style="width: 100%"
                    highlight-current-row
                    @current-change="changeCounter"
                >
                    <el-table-column prop="kind_name" :label="$t('common.counter') "></el-table-column>
                    <el-table-column prop="wgt" label="重量"></el-table-column>
                    <el-table-column prop="qty" label="数量"></el-table-column>
                </el-table>
            </div>
            <div class="chart_warpper">
                <div class="change_warpper">
                    <span :class="isaurify ? 'active' : ''" @click="changewgt('1')">重量</span>
                    <span :class="isaurify ? '' : 'active'" @click="changeqty('1')">数量</span>
                </div>
                <div id="aurify" :style="{ width: '100%', height: '500px' }"></div>
            </div>
            <div class="chart_warpper">
                <div class="change_warpper">
                    <span :class="iscatestock ? 'active' : ''" @click="changewgt('2')">重量</span>
                    <span :class="iscatestock ? '' : 'active'" @click="changeqty('2')">数量</span>
                </div>
                <div id="catestock" :style="{ width: '100%', height: '500px' }"></div>
            </div>
            <div class="chart_warpper">
                <div class="change_warpper">
                    <span :class="isitemstock ? 'active' : ''" @click="changewgt('3')">重量</span>
                    <span :class="isitemstock ? '' : 'active'" @click="changeqty('3')">数量</span>
                </div>
                <div id="itemstock" :style="{ width: '100%', height: '500px' }"></div>
            </div>
        </div>
        <div class="botton">
            <div class="product_warpper">
                <div id="product" style="width: 100%; height: 900px"></div>
            </div>
            <div class="table_warpper">
                <p>库存详情</p>
                <el-table :data="screenData.style_dtl" border style="width: 100%">
                    <el-table-column prop="counter_name" :label="$t('common.counter') "></el-table-column>
                    <el-table-column prop="gold_name" label="金成色"></el-table-column>
                    <el-table-column prop="type_name" label="品类"></el-table-column>
                    <el-table-column prop="kind_name" label="品目"></el-table-column>
                    <el-table-column prop="wgt" sortable label="重量"></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="analyseForm.pageIndex"
                        :page-size="analyseForm.page_size"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { analysePull, analyse } from '@/request/api';

export default {
    data() {
        return {
            data: [],
            pullData: {},
            analyseForm: {
                counter_no: [],
                type_no: [],
                kind_no: [],
                gold_no: [],
                style_no: [],
                counter_type: '',
                page_size: 20,
                page: 1
            },
            pageTotal: 1,
            screenData: {},
            productDetail: [],

            isaurify: true, //切换图标重量、数量
            iscatestock: true,
            isitemstock: true,

            chartData: {}, //echarts图表数据

            currentRow: null,
            counterData: [], //柜台数据
            isrefush: true //是否刷新柜台列表
        };
    },
    mounted() {
        this.getPull();
        this.screen();
    },
    methods: {
        // 获取下拉数据
        getPull() {
            analysePull({}).then((res) => {
                this.pullData = res.data;
            });
        },
        // 筛选操作
        onscreen() {
            this.analyseForm.counter_type = '';
            this.isrefush = true;

            this.screen();
        },
        //清空
        cencel() {
            let analyseForm = {
                counter_no: [],
                type_no: [],
                kind_no: [],
                gold_no: [],
                style_no: [],
                counter_type: '',
                page_size: 20,
                page: 1
            };

            this.analyseForm = analyseForm;
            this.screen();
        },
        // 默认渲染
        screen() {
            let analyseForm = this.$deepClone(this.analyseForm);
            for (const i in analyseForm) {
                if (Object.hasOwnProperty.call(analyseForm, i)) {
                    const element = analyseForm[i].toString();
                    analyseForm[i] = analyseForm[i].toString();
                }
            }
            analyse({ ...analyseForm }).then((res) => {
                this.isaurify = true;
                this.iscatestock = true;
                this.isitemstock = true;
                this.screenData = res.data.data;
                if (this.isrefush) {
                    this.counterData = res.data.data.counter;
                }
                this.pageTotal = res.data.count;
                // echarts模板
                let aurify = this.$echarts.init(document.getElementById('aurify'));
                let catestock = this.$echarts.init(document.getElementById('catestock'));
                let itemstock = this.$echarts.init(document.getElementById('itemstock'));
                // echarts渲染数据
                let wgtAurify = this.vilidate(res.data.data.gold, 'wgt');
                let wgtcatestocck = this.vilidate(res.data.data.type, 'wgt');
                let wgtitemstock = this.vilidate(res.data.data.kind, 'wgt');
                let qtyAurify = this.vilidate(res.data.data.gold, 'qty');
                let qtycatestocck = this.vilidate(res.data.data.type, 'qty');
                let qtyitemstock = this.vilidate(res.data.data.kind, 'qty');
                this.chartData = {
                    wgtAurify,
                    wgtcatestocck,
                    wgtitemstock,
                    qtyAurify,
                    qtycatestocck,
                    qtyitemstock
                };
                // 调用方法渲染
                this.mychart(aurify, '金成色', wgtAurify, '重量');
                this.mychart(catestock, '品类库存', wgtcatestocck, '重量');
                this.mychart(itemstock, '品目库存', wgtitemstock, '重量');

                let product = this.$echarts.init(document.getElementById('product'));
                let wgtproduct = this.vilidate(res.data.data.style, 'wgt');
                this.mychart_t(product, '产品结构', wgtproduct);
            });
        },
        // 改变柜台
        changeCounter(row) {
            if (row) {
                this.currentRow = row;
                this.isrefush = false;
                this.$set(this.analyseForm, 'counter_no', []);
                this.$set(this.analyseForm, 'counter_no', [row.counter_no]);
                this.$set(this.analyseForm, 'counter_type', row.counter_no);

                this.screen();
            }
        },
        // 取消关联
        setCurrent(row) {
            this.$refs.singleTable.setCurrentRow(row);
            this.$set(this.analyseForm, 'counter_no', []);
            this.$set(this.analyseForm, 'counter_type', '');
            this.screen();
        },
        // charts数据处理
        vilidate(data, type) {
            let arrdata = [];
            data.forEach((item) => {
                let obj;
                if (type == 'wgt') {
                    obj = {
                        name: item.kind_name,
                        value: Math.abs(item.wgt),
                        values: item.wgt
                    };
                } else if (type == 'qty') {
                    obj = {
                        name: item.kind_name,
                        value: Math.abs(item.qty),
                        values: item.qty
                    };
                }

                arrdata.push(obj);
            });
            return arrdata;
        },
        // 饼图
        mychart(chart, title, data, name) {
            chart.setOption({
                title: {
                    text: title,
                    left: 'left',
                    textStyle: {
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: (item) => {
                        let tip = '';
                        tip = `${item.seriesName}</br>${item.data.name}:${item.data.values}`;
                        return tip;
                    }
                },

                legend: {
                    orient: 'horizontal',
                    bottom: '0',
                    type: 'scroll'
                },
                series: [
                    {
                        name: name,
                        type: 'pie',
                        radius: '50%',
                        data: data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });
        },
        // 倒三角图
        mychart_t(chart, title, data) {
            chart.setOption({
                title: {
                    text: title,
                    textStyle: {
                        fontSize: 14
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c}'
                },

                legend: {
                    bottom: '0%',
                    type: 'scroll'
                },
                series: [
                    {
                        name: '重量',
                        type: 'funnel',
                        left: '10%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '0%',
                        maxSize: '100%',
                        sort: 'descending',
                        gap: 2,
                        label: {
                            show: true,
                            position: 'inside'
                        },
                        labelLine: {
                            length: 10,
                            lineStyle: {
                                width: 1,
                                type: 'solid'
                            }
                        },
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        emphasis: {
                            label: {
                                fontSize: 20
                            }
                        },
                        data: data
                    }
                ]
            });
        },
        // 切换重量
        changewgt(index) {
            if (index == 1) {
                this.isaurify = true;
                let aurify = this.$echarts.init(document.getElementById('aurify'));
                this.mychart(aurify, '金成色', this.chartData.wgtAurify, '重量');
            } else if (index == 2) {
                this.iscatestock = true;
                let catestock = this.$echarts.init(document.getElementById('catestock'));
                this.mychart(catestock, '品类库存', this.chartData.wgtcatestocck, '重量');
            } else if (index == 3) {
                this.isitemstock = true;
                let itemstock = this.$echarts.init(document.getElementById('itemstock'));
                this.mychart(itemstock, '品目库存', this.chartData.wgtitemstock, '重量');
            }
        },
        // 切换数量
        changeqty(index) {
            if (index == 1) {
                this.isaurify = false;
                let aurify = this.$echarts.init(document.getElementById('aurify'));
                this.mychart(aurify, '金成色', this.chartData.qtyAurify, '数量');
            } else if (index == 2) {
                this.iscatestock = false;
                let catestock = this.$echarts.init(document.getElementById('catestock'));
                this.mychart(catestock, '品类库存', this.chartData.qtycatestocck, '数量');
            } else if (index == 3) {
                this.isitemstock = false;
                let itemstock = this.$echarts.init(document.getElementById('itemstock'));
                this.mychart(itemstock, '品目库存', this.chartData.qtyitemstock, '数量');
            }
        }, // 分页导航
        handlePageChange(val) {
            this.$set(this.analyseForm, 'page', val);
            this.screen();
        }
    }
};
</script>

<style scoped lang="scss">
.warpper {
    background-color: #ece9e9;

    & > div {
        width: 100%;
    }

    .top {
        display: flex;

        .select_warpper {
            background-color: #fff;
            padding: 8px;
            margin-right: 8px;
            border-radius: 8px;
            width: 25%;
            .select_container {
                width: 100%;
            }
            p {
                font-size: 14px;
                font-weight: 600;
                color: #333;
            }
        }

        .buttom {
            margin-left: 10px;
            width: 150px;
        }
    }

    .center {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;

        .screen_table {
            width: 23%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            border-radius: 10px;
            background-color: #fff;
            padding: 5px;
            .el_table {
                cursor: pointer;
            }
            .table_top {
                width: 100%;
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                font-weight: 600;
                color: #333;
                margin-bottom: 5px;
            }
        }

        .chart_warpper {
            width: 25%;
            background-color: #fff;
            border-radius: 10px;
            position: relative;

            .change_warpper {
                width: 100%;
                text-align: center;
                position: absolute;
                left: 0;
                top: 25px;
                z-index: 99999;
                span {
                    border: 1px solid #ece9e9;
                    display: inline-block;
                    font-size: 12px;
                    color: #333;
                    padding: 5px 15px;
                    border-radius: 5px 0 0 5px;
                    cursor: pointer;
                    box-sizing: border-box;
                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        border-left: none;
                    }
                    &.active {
                        background-color: #409eff;
                        color: #fff;
                    }
                }
            }
        }
    }

    .botton {
        display: flex;
        justify-content: space-between;

        .product_warpper {
            width: 40%;
            background-color: #fff;
            border-radius: 8px;
        }

        .table_warpper {
            width: 58.5%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            padding: 8px;
            border-radius: 8px;

            p {
                width: 100%;
                font-size: 14px;
                text-align: left;
                font-weight: 600;
                color: #333;
            }
        }
    }
}
</style>